import { render, staticRenderFns } from "./create-course.vue?vue&type=template&id=4740ba26&scoped=true"
import script from "./create-course.vue?vue&type=script&lang=js"
export * from "./create-course.vue?vue&type=script&lang=js"
import style0 from "./create-course.vue?vue&type=style&index=0&id=4740ba26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4740ba26",
  null
  
)

export default component.exports